import script from "./WatchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchComponent.vue?vue&type=script&setup=true&lang=js"

import "./WatchComponent.vue?vue&type=style&index=0&id=94ab2ed8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94ab2ed8"]])

export default __exports__